import React from 'react';
import {View, Text, StyleSheet, TextStyle} from 'react-native';
import {Sizes, TextStyles, Colors, TextAlign} from '../index';
import {ComponentProps} from './ComponentProps';

interface LabelProps extends ComponentProps {
  text: string;
  isRequired?: boolean;
  textAlign?: TextAlign;
  paddingVertical?: number | string | undefined;
}

export const LabelSmall = (props: LabelProps) => {
  return <Label {...{...props, textStyle: TextStyles.textMediumS, paddingVertical: Sizes.s}} />;
};

export const LabelMedium = (props: LabelProps) => {
  return <Label {...{...props, textStyle: TextStyles.textMediumM, paddingVertical: Sizes.s}} />;
};

export const LabelLarge = (props: LabelProps) => {
  return <Label {...{...props, textStyle: TextStyles.textMediumL, paddingVertical: Sizes.m}} />;
};

export interface LabelComponentProps extends LabelProps {
  textStyle: TextStyle;
}

const Label = (props: LabelComponentProps) => {
  let textStyle: TextStyle[] = [
    props.textStyle,
    {
      flex: 1,
      color: Colors.neutralDarker,
      textAlign: props.textAlign ?? 'left',
      paddingVertical: props.paddingVertical,
    },
  ];
  const required = props.isRequired ?? false ? ' *' : '';
  return (
    <View style={props.containerStyle}>
      <View style={styles.container} testID={props.testID}>
        <Text style={textStyle}>{props.text + required}</Text>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
  },
});
